import { IClassname } from '@/lib/shared/model/classname';

export const TerritorySVG = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.87057 6H25.1319C25.1319 6 26.0015 6 26.0015 6.86959V25.131C26.0015 25.131 26.0015 26.0005 25.1319 26.0005H6.87057C6.87057 26.0005 6.00098 26.0005 6.00098 25.131V6.86959C6.00098 6.86959 6.00098 6 6.87057 6Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.2 22C9.2 22.4418 9.55817 22.8 10 22.8H17.2C17.6418 22.8 18 22.4418 18 22C18 21.5582 17.6418 21.2 17.2 21.2H10.8V14.8C10.8 14.3582 10.4418 14 10 14C9.55817 14 9.2 14.3582 9.2 14.8V22ZM22.8 10C22.8 9.55817 22.4418 9.2 22 9.2H14.8C14.3582 9.2 14 9.55817 14 10C14 10.4418 14.3582 10.8 14.8 10.8H21.2V17.2C21.2 17.6418 21.5582 18 22 18C22.4418 18 22.8 17.6418 22.8 17.2V10ZM10 22L10.5657 22.5657L22.5657 10.5657L22 10L21.4343 9.43431L9.43431 21.4343L10 22Z"
        fill="currentColor"
      />
    </svg>
  );
};
